import classNames from 'classnames';
import { Avatar, Button, Dropdown, Tooltip } from 'react-daisyui';
import { randomString } from '../../functions/string.functions';
import './Avatars.styles.scss';
import { tAvatar, tAvatarsProps } from './Avatars.types';

export default function Avatars(props: tAvatarsProps) {
  const { avatars, maxItems, showSelected } = props;
  let items: tAvatar[] = avatars;

  const showPlaceholder = items.length > maxItems;
  const letters = showPlaceholder ? `+ ${items.length - maxItems}` : undefined;
  let dropdownItems: tAvatar[] = [];

  if (showPlaceholder) {
    dropdownItems = items.slice(maxItems);
    items = items.slice(0, maxItems);

    items.push({
      letters,
      src: undefined,
      size: 'xs',
      shape: 'circle',
      color: 'primary',
      tooltipLabel: '',
      isPlaceholder: true,
    });
  }

  let avatarClassNames = 'border-0';

  return (
    <Avatar.Group className="Avatars">
      {items.map((item) => {
        const { tooltipLabel, onClick, isSelected, ...avatarProps } = item;

        let buttonColor:
          | 'primary'
          | 'neutral'
          | 'secondary'
          | 'accent'
          | 'ghost'
          | 'info'
          | 'success'
          | 'warning'
          | 'error'
          | undefined = 'ghost';

        if (showSelected) {
          buttonColor = isSelected ? 'accent' : 'ghost';
          avatarClassNames = classNames({
            'border-0': isSelected,
          });
        }

        let output = (
          <Tooltip key={randomString()} message={tooltipLabel}>
            <Button
              shape="circle"
              color={buttonColor}
              onClick={() => onClick?.()}
            >
              <span className="Avatars__Item">
                <Avatar
                  {...avatarProps}
                  shape="circle"
                  size="xs"
                  color="primary"
                  className={avatarClassNames}
                />
                {/* Only drawn when presence is actually known: an undefined
                    flag renders nothing rather than implying "active". */}
                {item.isInactive !== undefined ? (
                  <span
                    className={classNames('Avatars__Presence', {
                      'Avatars__Presence--inactive': item.isInactive,
                    })}
                  />
                ) : null}
              </span>
            </Button>
          </Tooltip>
        );

        if (item.isPlaceholder) {
          output = (
            <Dropdown horizontal="left" vertical="bottom">
              <Dropdown.Toggle color="ghost" className="rounded-full -ml-1">
                <Avatar
                  {...avatarProps}
                  shape="circle"
                  size="xs"
                  color="primary"
                  className={avatarClassNames}
                />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {dropdownItems.map((item) => {
                  const { tooltipLabel, onClick, isSelected, ...avatarProps } =
                    item;

                  if (showSelected) {
                    buttonColor = isSelected ? 'accent' : 'ghost';
                    avatarClassNames = classNames({
                      'border-0': isSelected,
                    });
                  }

                  return (
                    <Dropdown.Item
                      key={randomString()}
                      onClick={() => onClick?.()}
                    >
                      <Button shape="circle" color={buttonColor}>
                        <Avatar
                          {...avatarProps}
                          shape="circle"
                          size="xs"
                          color="primary"
                          className={avatarClassNames}
                        />
                      </Button>
                      {tooltipLabel}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          );
        }

        return output;
      })}
    </Avatar.Group>
  );
}
